import React from "react";
import xMarkIcon from "../assets/icons/xmark.svg";
import "../styles/layoutStyles.css";

interface MigrationBannerProps {
  onClose: () => void;
}

const MigrationBanner: React.FC<MigrationBannerProps> = ({ onClose }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: "var(--color-brand-red)",
        color: "white",
        padding: "12px 20px",
        textAlign: "center",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        zIndex: 1001,
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <div style={{ flex: 1, textAlign: "center" }}>
        <span>
          <strong>
            This version of Motics will be phased out by 30th September 2025
            (extended from 31st July 2025). Please contact us at{" "}
            <a
              href="mailto:hello@motics.co.uk"
              style={{ color: "white", textDecoration: "underline" }}
            >
              hello@motics.co.uk
            </a>{" "}
            or via Intercom to migrate to our new version.
          </strong>
        </span>
      </div>
      <button
        className="small-icon-button"
        onClick={onClose}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: "4px",
          marginLeft: "12px",
        }}
      >
        <img
          src={xMarkIcon}
          className="small-icon-button"
          alt="close"
          style={{
            filter: "brightness(0) invert(1)",
            width: "16px",
            height: "16px",
          }}
        />
      </button>
    </div>
  );
};

export default MigrationBanner;
